import { isEmpty } from "./isEmpty-B2dexaif.mjs";

//#region src/isNotEmpty.ts
/**
* @category Logic
*/
function isNotEmpty(val) {
	return !isEmpty(val);
}
var isNotEmpty_default = isNotEmpty;

//#endregion
export { isNotEmpty_default };
//# sourceMappingURL=isNotEmpty-ByvaEFOI.mjs.map